import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useTransition } from '../context/TransitionContext'

interface NavLinkProps {
  to: string
  children: React.ReactNode
}

function NavLink({ to, children }: NavLinkProps) {
  const location = useLocation()
  const { triggerTransition } = useTransition()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    triggerTransition(to, children?.toString() || '')
  }

  return (
    <Link
      to={to}
      onClick={handleClick}
      className={`hover:opacity-70 transition-opacity px-4 py-2 rounded-full font-medium text-md ${
        location.pathname === to ? 'bg-gray-100' : ''
      }`}
    >
      {children}
    </Link>
  )
}

export default NavLink
